'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReferrer = undefined;

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('utils/Analytics');

var getReferrer = exports.getReferrer = function getReferrer() {
  if (!_AppConfigContainer2.default.has('referrer')) {
    LOG.warn('Referrer not set on AppConfigContainer');
  }

  return _AppConfigContainer2.default.get('referrer');
};